export const ACADEMY_PORTAL_ID = 137828;